import {useEffect} from "react";

export const useWindowMessages = (func) => {
    useEffect(() => {
        function onMessage(event) {
            if (typeof event.data === 'object' && /^react-devtools/.test(event.data.source)) {
                return;
            }
            func(event.data);
        }
        window.addEventListener("message", onMessage);
        return () => window.removeEventListener("message", onMessage);
    }, [func]);
};
